var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{staticClass:"undo",attrs:{"viewBox":"0 0 32 32"}},[_c('path',{attrs:{"d":"M23.808 32c3.554-6.439 4.153-16.26-9.808-15.932v7.932l-12-12 12-12v7.762c16.718-0.436 18.58 14.757 9.808 24.238z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }